module.exports = __webpack_public_path__ + "img/alert_check_admin2.4078f523.png";